import React, { useState, JSX } from 'react';
import '../CSS/Accordion.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import RichTextComponents from './RichTextComponents';

const CustomAccordion: React.FC<{ element: any }> = ({ element }) => {
  const [isExpanded, setExpanded] = useState(false);

  const handleToggle = (): void => {
    setExpanded(!isExpanded);
  };

  const colorMap: { [key: string]: string } = {
    accordion_standard: '#003370',
    accordion_cyu: '#29a7c1',
    accordion_ayk: '#c25a14',
    accordion_wdy: '#650964',
  };

  const accordionColor =
    colorMap[element.accordion_style.value[0].codename] || '#000'; // Default to black if not found

  const iconColor = {
    color: accordionColor,
  };
  const renderContentByColor = (): JSX.Element => {
    switch (accordionColor) {
      case '#003370':
        return (
          <div className="accordion-panel-group ">
            <div className="panel panel-primary accordion-panel-primary">
              <Accordion
                expanded={isExpanded}
                onChange={handleToggle}
                sx={{
                  '& .MuiAccordionSummary-root': {
                    padding: '0px 8px',
                  },
                  '& .MuiAccordionDetails-root': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    // paddingLeft: '0px',
                    // paddingRight: '0px',
                  },

                  '& .MuiAccordionSummary-root.Mui-expanded': {
                    minHeight: '0px',
                  },

                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                    padding: '0px',
                  },
                }}
              >
                <AccordionSummary
                  aria-controls="panel-content"
                  id="panel-header"
                  sx={{
                    '& .MuiAccordionSummary-expandIconWrapper': iconColor,

                    '& .MuiAccordionSummary-content': {
                      display: 'inline-block',
                      // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      // margin: '0px',
                    },

                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      // display: 'inline-block',
                      // // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      margin: '0px',
                    },
                  }}
                >
                  <div className="accordion-panel-heading">
                    <h4 className="accordion-panel-title">
                      <span
                        style={{
                          verticalAlign: 'middle',
                          display: 'inline-block',
                          width: '90%',
                        }}
                      >
                        {element.panel.value}
                      </span>
                      {isExpanded ? (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="accordion-toggle glyphicon glyphicon-minus"
                        ></span>
                      ) : (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="accordion-toggle collapsed glyphicon glyphicon-plus"
                        ></span>
                      )}
                    </h4>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  className="accordion-panel-primary accordion-panel-body"
                  id="panel-content"
                  aria-labelledby="panel-header"
                  sx={{
                    '& .MuiAccordionDetails-root': {
                      padding: '0px',
                    },
                  }}
                >
                  {isExpanded ? (
                    <div className="panel-collapse collapse in">
                      <RichTextComponents element={element.accordion_content} />
                    </div>
                  ) : (
                    <div
                      className="panel-collapse collapse"
                      style={{ height: '10px' }}
                    ></div>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        );
      case '#29a7c1':
        return (
          <div className="panel-group cyu-panel-group ">
            <div className="panel panel-primary cyu-panel-primary">
              <Accordion
                expanded={isExpanded}
                onChange={handleToggle}
                sx={{
                  '& .MuiAccordionSummary-root': {
                    padding: '0px 8px',
                  },
                  '& .MuiAccordionDetails-root': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    // paddingLeft: '0px',
                    // paddingRight: '0px',
                  },

                  '& .MuiAccordionSummary-root.Mui-expanded': {
                    minHeight: '0px',
                  },

                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                    padding: '0px',
                  },
                }}
              >
                <AccordionSummary
                  aria-controls="panel-content"
                  id="panel-header"
                  sx={{
                    '& .MuiAccordionSummary-expandIconWrapper': iconColor,

                    '& .MuiAccordionSummary-content': {
                      display: 'inline-block',
                      // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      // margin: '0px',
                    },

                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      // display: 'inline-block',
                      // // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      margin: '0px',
                    },
                  }}
                >
                  <div className="panel-cyuheading">
                    <h4 className="cyu-title">
                      <span
                        style={{
                          verticalAlign: 'middle',
                          display: 'inline-block',
                          width: '90%',
                        }}
                      >
                        <i>{element.panel.value}</i>
                      </span>
                      {isExpanded ? (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="cyu-toggle glyphicon glyphicon-minus"
                        ></span>
                      ) : (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="cyu-toggle collapsed glyphicon glyphicon-plus"
                        ></span>
                      )}
                    </h4>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  className="cyu-panel-primary"
                  id="panel-content"
                  aria-labelledby="panel-header"
                  sx={{
                    '& .MuiAccordionDetails-root': {
                      padding: '0px',
                    },
                  }}
                >
                  {isExpanded ? (
                    <span className="panel-collapse CYUFeedback collapse in"></span>
                  ) : (
                    <span className="panel-collapse CYUFeedback collapse"></span>
                  )}
                  <span>
                    <RichTextComponents element={element.accordion_content} />
                  </span>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        );
      case '#c25a14':
        return (
          <div className="panel-group ayk-panel-group ">
            <div className="panel panel-primary ayk-panel-primary">
              <Accordion
                expanded={isExpanded}
                onChange={handleToggle}
                sx={{
                  '& .MuiAccordionSummary-root': {
                    padding: '0px 8px',
                  },
                  '& .MuiAccordionDetails-root': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    // paddingLeft: '0px',
                    // paddingRight: '0px',
                  },

                  '& .MuiAccordionSummary-root.Mui-expanded': {
                    minHeight: '0px',
                  },

                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                    padding: '0px',
                  },
                }}
              >
                <AccordionSummary
                  sx={{
                    '& .MuiAccordionSummary-expandIconWrapper': iconColor,

                    '& .MuiAccordionSummary-content': {
                      display: 'inline-block',
                      // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      // margin: '0px',
                    },

                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      // display: 'inline-block',
                      // // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      margin: '0px',
                    },
                  }}
                  aria-controls="panel-content"
                  id="panel-header"
                >
                  <div className="panel-aykheading">
                    <h4 className="ayk-title">
                      <span
                        style={{
                          verticalAlign: 'middle',
                          display: 'inline-block',
                          width: '90%',
                        }}
                      >
                        <i>{element.panel.value}</i>
                      </span>
                      {isExpanded ? (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="ayk-toggle glyphicon glyphicon-minus"
                        ></span>
                      ) : (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="ayk-toggle collapsed glyphicon glyphicon-plus"
                        ></span>
                      )}
                    </h4>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  className="ayk-panel-primary"
                  id="panel-content"
                  aria-labelledby="panel-header"
                  sx={{
                    '& .MuiAccordionDetails-root': {
                      padding: '0px',
                    },
                  }}
                >
                  {isExpanded ? (
                    <span className="panel-collapse AYKFeedback collapse in"></span>
                  ) : (
                    <span className="panel-collapse AYKFeedback collapse"></span>
                  )}
                  <span>
                    <RichTextComponents element={element.accordion_content} />
                  </span>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        );
      case '#650964':
        return (
          <div className="panel-group wdy-panel-group ">
            <div className="panel panel-primary wdy-panel-primary">
              <Accordion
                expanded={isExpanded}
                onChange={handleToggle}
                sx={{
                  '& .MuiAccordionSummary-root': {
                    padding: '0px 8px',
                  },
                  '& .MuiAccordionDetails-root': {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    // paddingLeft: '0px',
                    // paddingRight: '0px',
                  },

                  '& .MuiAccordionSummary-root.Mui-expanded': {
                    minHeight: '0px',
                  },

                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                    padding: '0px',
                  },
                }}
              >
                <AccordionSummary
                  sx={{
                    '& .MuiAccordionSummary-expandIconWrapper': iconColor,

                    '& .MuiAccordionSummary-content': {
                      display: 'inline-block',
                      // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      // margin: '0px',
                    },

                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      // display: 'inline-block',
                      // // marginTop: '0px' ,
                      // marginBottom: '0px' ,
                      // marginLeft: '7px',
                      // marginRight: '10px',
                      // paddingBottom: '0px',
                      margin: '0px',
                    },
                  }}
                  aria-controls="panel-content"
                  id="panel-header"
                >
                  <div className="panel-wdyheading">
                    <h4 className="wdy-title">
                      <span
                        style={{
                          verticalAlign: 'middle',
                          display: 'inline-block',
                          width: '90%',
                        }}
                      >
                        <i>{element.panel.value}</i>
                      </span>
                      {isExpanded ? (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="wdy-toggle glyphicon glyphicon-minus"
                        ></span>
                      ) : (
                        <span
                          style={{
                            width: '10%',
                            verticalAlign: 'middle',
                            textAlign: 'right',
                          }}
                          className="wdy-toggle collapsed glyphicon glyphicon-plus"
                        ></span>
                      )}
                    </h4>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  className="wdy-panel-primary"
                  id="panel-content"
                  aria-labelledby="panel-header"
                  sx={{
                    '& .MuiAccordionDetails-root': {
                      padding: '0px',
                    },
                  }}
                >
                  {isExpanded ? (
                    <span className="panel-collapse  WDYFeedback collapse in"></span>
                  ) : (
                    <span className="panel-collapse  WDYFeedback collapse"></span>
                  )}
                  <span>
                    <RichTextComponents element={element.accordion_content} />
                  </span>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return <div>{renderContentByColor()}</div>;
};

export default CustomAccordion;
